export default "__VITE_ASSET__kIRieO$H__"